export namespace FilterValueConstants {
  export const ServerPortDefault = 'default';
}